export { UsingTermsPage as default } from '@/components/enpages/Legal/UsingTerms'
